export const environment = {
  production: false,
  api: 'https://api-test.vasorder.com/api',
  baseApi: 'https://api-test.vasorder.com',
  reCaptcha: {
    siteKey: '6LdE8_cpAAAAAGiGl9X3LmxDizv9dJ3OwltMJzhy',
  },
  pricePassword: '12345678',
};
